import {
    CLICK_MODAL_OPEN,
    CLICK_MODAL_PREV,
    CLICK_MODAL_NEXT,
    CLICK_MODAL_CLOSE,
} from '@/shared/components/photo_gallery/constants/action_types';

// 初期値
const initialState = {
    index: null,
};

// Action の種別によってステータスを更新
export default (state = initialState, action) => {
    switch (action.type) {
        case CLICK_MODAL_OPEN: {
            window.St.modal = true;

            return {
                index: action.payload.index,
            };
        }
        case CLICK_MODAL_CLOSE: {
            window.St.modal = false;

            return {
                index: null,
            };
        }
        case CLICK_MODAL_PREV: {
            return {
                index: action.payload.prev,
            };
        }
        case CLICK_MODAL_NEXT: {
            return {
                index: action.payload.next,
            };
        }
        default: {
            return state;
        }
    }
};
